export const MY_TEAM = 'MY_TEAM';
export const OTHER_TEAMS = 'OTHER_TEAMS';

export const TEAMS = [
  {
    name: MY_TEAM,
    label: 'My Team',
  },
  {
    name: OTHER_TEAMS,
    label: 'Other \nTeams',
  },
];
